export var LegacyCardRatioOptions;
(function (LegacyCardRatioOptions) {
    LegacyCardRatioOptions["RATIO_100"] = "100";
    LegacyCardRatioOptions["RATIO_50_50"] = "50";
    LegacyCardRatioOptions["RATIO_40_60"] = "40";
    LegacyCardRatioOptions["RATIO_30_70"] = "30";
})(LegacyCardRatioOptions || (LegacyCardRatioOptions = {}));
//# sourceMappingURL=types.js.map